/** 表格页面操作类型 */
export const TableActionType = {
    /** 详情 */
    detail: 'detail',

    /** 创建 */
    create: 'create',

    /** 编辑 */
    edit: 'edit',

    /** 删除 */
    delete: 'delete',

    /** 切换状态 */
    state: 'state',

    /** 排序 */
    sort: 'sort',

    /** 链接 */
    link: 'link',

    /** 开启 */
    start: 'start',

    /** 关闭 */
    stop: 'stop',

    /** 批量操作 */
    batch: 'batch',

    /** 确认 */
    sure: 'sure'
};

